import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./style.css";
import { Drawer, List, ListItem, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import RoofingOutlinedIcon from "@mui/icons-material/RoofingOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import CreditScoreOutlinedIcon from "@mui/icons-material/CreditScoreOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import { useSelector, useDispatch } from "react-redux";
import { handleSidebar } from "../feaures/store/redux/web/enquirySlice";

const Sidebar = ({logo}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const enquiryStore = useSelector((state) => state.enquirySlice);

  const toggleDrawer = () => {
    dispatch(handleSidebar(false));
  };

  const menuItems = [
    {
      text: "Home",
      path: "/",
      icon: <HomeOutlinedIcon className="icon" />,
    },

    {
      text: "Events",
      path: "/events",
      icon: <EmojiEventsOutlinedIcon className="icon" />,
    },
    {
      text: "Seller Options",
      path: "/seller-options",
      icon: <SellOutlinedIcon className="icon" />,
    },
    {
      text: "Customised Construction",
      path: "/customised-construction",
      icon: <RoofingOutlinedIcon className="icon" />,
    },
    {
      text: "Insurance Facilities",
      path: "/insurance-facilities",
      icon: <PendingActionsOutlinedIcon className="icon" />,
    },
    {
      text: "Loan Facilities",
      path: "/loan-facilities",
      icon: <CreditScoreOutlinedIcon className="icon" />,
    },
    {
      text: "Gallery",
      path: "/gallery",
      icon: <CollectionsOutlinedIcon className="icon" />,
    },
    {
      text: "Testimonials",
      path: "/testimonials",
      icon: <AssistantOutlinedIcon className="icon" />,
    },
    {
      text: "Feedback",
      path: "/feedback",
      icon: <ThumbUpAltOutlinedIcon className="icon" />,
    },
    {
      text: "About Us",
      path: "/about",
      icon: <InfoOutlinedIcon className="icon" />,
    },
    {
      text: "Contact Us",
      path: "/contact",
      icon: <AccountCircleOutlinedIcon className="icon" />,
    },
  ];
  return (
    <>
      <div className="sidebar">
        <ul className="menu">
          {menuItems.map((item) => (
            <li>
              <NavLink
                to={item.path}
                className={({ isActive }) => (isActive ? "active" : "")}
                key={item.text}
              >
                {item.icon} {item.text}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
      <div className="side-menubar">
        {/* <IconButton onClick={toggleDrawer} className="menu-icon">
          {open ? <CloseIcon /> : <MenuIcon />}
        </IconButton> */}
        <Drawer
          anchor="left"
          open={enquiryStore.sidebar.isOpen}
          onClose={toggleDrawer}
        >
          <List className="sidebar-drawer">
            <ListItem
              button
              key={"item"}
              style={{ padding: "0", width: "100%" }}
            >
              <NavLink
                style={{
                  borderBottom: "1px solid lightgray",
                  fontSize: "18px",
                  fontWeight: "400",
                  width: "100%",
                  padding: "0 0px 0px 10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Richpremises</span>
                <img src={logo} alt="logo" width={"50px"} />
              </NavLink>
            </ListItem>

            {menuItems.map((item) => (
              <ListItem
                button
                key={item.text}
                style={{ padding: "0", width: "100%" }}
              >
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }
                  onClick={toggleDrawer}
                  style={{ padding: "10px", width: "100%" }}
                >
                  {item.text}
                </NavLink>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </div>
    </>
  );
};

export default Sidebar;
